import { all, put, select } from 'redux-saga/effects';

import { Insurance } from 'constants/routes';

import * as InsuranceActions from '../../actions';
import * as InsuranceConstants from '../../constants';
import { CreatePage } from '../../helpers';
import { insuranceStageCreateNewInsurance, insuranceStageGetInsuranceOrder } from '../../sagas';
import * as InsuranceSelectors from '../../selectors';

const { ROUTE_NAMES } = Insurance;

const PAGE_NAME = ROUTE_NAMES.CREATE_NEW;

export const insurancePageCreateNew = new CreatePage({
  action: InsuranceConstants.ACTIONS.CREATE_NEW,
  after: function* () {
    yield put(InsuranceActions.updatePagesLoadings({ [PAGE_NAME]: false }));
  },
  before: function* () {
    yield put(InsuranceActions.updatePagesLoadings({ [PAGE_NAME]: true }));
  },
  handler: function* (_, { runStage }) {
    const [carInstanceId, customerId] = yield all([
      select(InsuranceSelectors.interlayerSelectCarInstanceId),
      select(InsuranceSelectors.interlayerSelectCustomerId),
    ]);

    const needCreateNew = ![carInstanceId, customerId].some(Boolean);

    if (needCreateNew) {
      yield* runStage(insuranceStageCreateNewInsurance);
    }

    yield* runStage(insuranceStageGetInsuranceOrder);
  },
  name: PAGE_NAME,
}).watcher;
